import { isPlatformBrowser } from '@angular/common';
import { Directive, Output, EventEmitter, ElementRef, OnInit, DOCUMENT, Inject, PLATFORM_ID, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';

@Directive({
    selector: '[ng-clickOutside]',
    standalone: false
})
export class ClickOutsideDirective implements OnInit {
    @Output() clickOutside = new EventEmitter<void>();
    destroyRef = inject(DestroyRef);

    constructor(
        private elementRef: ElementRef,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Inject(DOCUMENT) protected document: any,
    ) { }

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            fromEvent(this.document, 'click').pipe(
                filter(({ target }) => {
                    // console.log(target)
                    return !this.elementRef.nativeElement.contains(target);
                }),
                takeUntilDestroyed(this.destroyRef)
            ).subscribe(_ => {
                this.clickOutside.emit();
            });
        }
    }
}
